import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import { ForbiddenModalSpawnComponent } from './auth/forbidden-modal-spawn/forbidden-modal-spawn.component';
import { RefreshSessionComponent } from './auth/refresh-session/refresh-session.component';

const routes: Routes = [
  { path: 'auth-fail', component: ForbiddenModalSpawnComponent },
  { path: '**', component: RefreshSessionComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
})
export class AppRoutingModule {}
